export default function VideoCamera() {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4097_395)">
        <path
          d="M24 9.5V23.5C24 24.0304 23.7893 24.5391 23.4142 24.9142C23.0391 25.2893 22.5304 25.5 22 25.5H4C3.46957 25.5 2.96086 25.2893 2.58579 24.9142C2.21071 24.5391 2 24.0304 2 23.5V9.5C2 8.96957 2.21071 8.46086 2.58579 8.08579C2.96086 7.71071 3.46957 7.5 4 7.5H22C22.5304 7.5 23.0391 7.71071 23.4142 8.08579C23.7893 8.46086 24 8.96957 24 9.5ZM31.25 9.53125C31.1089 9.49673 30.9621 9.49247 30.8193 9.51875C30.6765 9.54504 30.5408 9.60127 30.4212 9.68375L26.2225 12.4825C26.154 12.5282 26.0979 12.5901 26.059 12.6627C26.0202 12.7353 25.9999 12.8164 26 12.8988V20.1012C25.9999 20.1836 26.0202 20.2647 26.059 20.3373C26.0979 20.4099 26.154 20.4718 26.2225 20.5175L30.445 23.3325C30.603 23.4379 30.7879 23.4962 30.9778 23.5004C31.1677 23.5046 31.3549 23.4546 31.5175 23.3563C31.6679 23.2606 31.7912 23.128 31.8757 22.9711C31.9602 22.8142 32.003 22.6382 32 22.46V10.5C32.0001 10.2782 31.9265 10.0627 31.7907 9.88732C31.655 9.71195 31.4647 9.5867 31.25 9.53125Z"
          fill="#944522"
        />
      </g>
      <defs>
        <clipPath id="clip0_4097_395">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
